export const duaCategories = [
    { id: 'quranic', name: 'Rabbana (Quran)', icon: 'FiBookOpen' },
    { id: 'morning', name: 'Morning', icon: 'FiSun' },
    { id: 'evening', name: 'Evening', icon: 'FiMoon' },
    { id: 'prayer', name: 'Prayer (Salah)', icon: 'FiTarget' },
    { id: 'food', name: 'Food & Drink', icon: 'FiCoffee' },
    { id: 'travel', name: 'Travel', icon: 'FiMap' },
    { id: 'forgiveness', name: 'Forgiveness', icon: 'FiRefreshCw' },
    { id: 'protection', name: 'Protection', icon: 'FiShield' },
    { id: 'illness', name: 'Illness & Shifa', icon: 'FiActivity' },
    { id: 'family', name: 'Family & Home', icon: 'FiHome' },
    { id: 'hajj', name: 'Hajj & Umrah', icon: 'FiGlobe' },
    { id: 'emotion', name: 'Stress & Sadness', icon: 'FiSmile' },
    { id: 'knowledge', name: 'Knowledge & Wisdom', icon: 'FiBook' },
    { id: 'parents', name: 'Parents', icon: 'FiUsers' },
    { id: 'ramadan', name: 'Ramadan & Fasting', icon: 'FiMoon' },
];

export const duas = [
    // --- QURANIC (RABBANA) ---
    {
        id: 101,
        category: 'quranic',
        title: 'Rabbana Atina (Good in both worlds)',
        arabic: 'رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ',
        transliteration: 'Rabbana atina fid-dunya hasanatan wa fil-akhirati hasanatan waqina \'adhaban-nar',
        translations: {
            english: 'Our Lord, give us in this world [that which is] good and in the Hereafter [that which is] good and protect us from the punishment of the Fire.',
            urdu: 'اے ہمارے رب! ہمیں دنیا میں بھی بھلائی دے اور آخرت میں بھی بھلائی دے اور ہمیں آگ کے عذاب سے بچا۔',
            hindi: 'ऐ हमारे रब! हमें दुनिया में भी भलाई दे और आखिरत में भी भलाई दे और हमें आग के अज़ाब से बचा।',
            bangla: 'হে আমাদের পালনকর্তা! আমাদিগকে দুনিয়াতে কল্যাণ দান কর এবং আখেরাতেও কল্যাণ দান কর এবং আমাদিগকে দোযখের আযাব হতে রক্ষা কর।'
        },
        reference: 'Surah Al-Baqarah 2:201',
        benefits: 'Comprehensive prayer for success in this life and the next. It is one of the most frequently recited duas by the Prophet (SAW).',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/002201.mp3'
    },
    {
        id: 102,
        category: 'quranic',
        title: 'Rabbana Hab Lana (Spouse & Offspring)',
        arabic: 'رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا',
        transliteration: 'Rabbana hab lana min azwajina wa dhurriyyatina qurrata a\'yunin waj\'alna lil-muttaqina imama',
        translations: {
            english: 'Our Lord, grant us from among our wives and offspring comfort to our eyes and make us an example for the righteous.',
            urdu: 'اے ہمارے رب! ہمیں اپنی بیویوں اور اولاد سے آنکھوں کی ٹھنڈک عطا فرما اور ہمیں پرہیزگاروں کا امام بنا۔',
            hindi: 'ऐ हमारे रब! हमें अपनी बीवियों और औलाद से आँखों की ठंडक अता फरमा और हमें परहेज़गारों का इमाम बना।',
            bangla: 'হে আমাদের পালনকর্তা! আমাদের স্ত্রীদের ও সন্তানদের পক্ষ থেকে আমাদের জন্য চোখের শীতলতা দান কর এবং আমাদেরকে মুত্তাকীদের জন্য আদর্শস্বরূপ কর।'
        },
        reference: 'Surah Al-Furqan 25:74',
        benefits: 'Prayer for a righteous family and to be a leader of the God-fearing.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/025074.mp3'
    },
    {
        id: 103,
        category: 'quranic',
        title: 'Rabbana La Tuzigh Qulubana (Steadfastness)',
        arabic: 'رَبَّنَا لاَ تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِن لَّدُنكَ رَحْمَةً إِنَّكَ أَنتَ الْوَهَّابُ',
        transliteration: 'Rabbana la tuzigh qulubana ba\'da idh hadaitana wa hab lana min ladunka rahmatan innaka antal-Wahhab',
        translations: {
            english: 'Our Lord, let not our hearts deviate after You have guided us and grant us from Yourself mercy. Indeed, You are the Bestower.',
            urdu: 'اے ہمارے رب! ہمارے دلوں کو ٹیڑھا نہ کر اس کے بعد کہ تو نے ہمیں ہدایت دی، اور ہمیں اپنی طرف سے رحمت عطا فرما، بے شک تو ہی بہت دینے والا ہے۔',
            hindi: 'ऐ हमारे रब! हमारे दिलों को टेढ़ा न कर इसके बाद कि तूने हमें हिदायत दी, और हमें अपनी तरफ से रहमत अता फरमा, बेशक तू ही बहुत देने वाला है।',
            bangla: 'হে আমাদের পালনকর্তা! সরল পথ প্রদর্শনের পর তুমি আমাদের অন্তরকে সত্যলংঘনে প্রবৃত্ত করোনা এবং তোমার নিকট থেকে আমাদিগকে অনুগ্রহ দান কর। তুমিই সব কিছুর দাতা।'
        },
        reference: 'Surah Al-Imran 3:8',
        benefits: 'Protection from guidance after finding the truth. Essential for maintaining faith.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/003008.mp3'
    },
    {
        id: 104,
        category: 'quranic',
        title: 'Rabbana Faghfir Lana (Forgiveness)',
        arabic: 'رَبَّنَا فَاغْفِرْ لَنَا ذُنُوبَنَا وَكَفِّرْ عَنَّا سَيِّئَاتِنَا وَتَوَفَّنَا مَعَ الأَبْرَارِ',
        transliteration: 'Rabbana faghfir lana dhunubana wa kaffir \'anna sayyi-atina wa tawaffana ma\'al-abrar',
        translations: {
            english: 'Our Lord, so forgive us our sins and remove from us our misdeeds and cause us to die with the righteous.',
            urdu: 'اے ہمارے رب! پس ہمارے گناہ بخش دے اور ہماری برائیاں ہم سے دور کر دے اور ہمیں نیک لوگوں کے ساتھ موت دے۔',
            hindi: 'ऐ हमारे रब! तो हमारे गुनाह बख्श दे और हमारी बुराइयां हमसे दूर कर दे और हमें नेक लोगों के साथ मौत दे।',
            bangla: 'হে আমাদের পালনকর্তা! সুতরাং আমাদের পাপসমূহ মোচন কর এবং আমাদের দোষ-ত্রুটি অপনোদন কর এবং সৎকর্মশীলদের সাথে আমাদের মৃত্যু দাও।'
        },
        reference: 'Surah Al-Imran 3:193',
        benefits: 'Seeking forgiveness and a good end (Husn al-Khatimah).',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/003193.mp3'
    },
    {
        id: 105,
        category: 'quranic',
        title: 'Rabbana Zalamna Anfusana (Prophet Yunus)',
        arabic: 'رَبَّنَا ظَلَمْنَا أَنفُسَنَا وَإِن لَّمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ',
        transliteration: 'Rabbana zalamna anfusana wa in lam taghfir lana wa tarhamna lanakunanna minal-khasirin',
        translations: {
            english: 'Our Lord, we have wronged ourselves, and if You do not forgive us and have mercy upon us, we will surely be among the losers.',
            urdu: 'اے ہمارے رب! ہم نے اپنی جانوں پر ظلم کیا، اور اگر تو نے ہمیں معاف نہ کیا اور ہم پر رحم نہ کیا تو ہم یقیناً نقصان اٹھانے والوں میں سے ہو جائیں گے۔',
            hindi: 'ऐ हमारे रब! हमने अपनी जानों पर ज़ुल्म किया, और अगर तूने हमें माफ न किया और हम पर रहम न किया तो हम यकीनन नुकसान उठाने वालों में से हो जाएंगे।',
            bangla: 'হে আমাদের পালনকর্তা! আমরা নিজেদের প্রতি অবিচার করেছি। যদি আপনি আমাদেরকে ক্ষমা না করেন এবং আমাদের প্রতি অনুগ্রহ না করেন, তবে আমরা অবশ্যই ক্ষতিগ্রস্তদের অন্তর্ভুক্ত হব।'
        },
        reference: 'Surah Al-A\'raf 7:23',
        benefits: 'The prayer of Adam (AS) and Hawwa (AS) for repentance. Great for seeking forgiveness.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/007023.mp3'
    },
    {
        id: 106,
        category: 'quranic',
        title: 'Rabbana Afrigh \'Alayna Sabran (Patience)',
        arabic: 'رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَثَبِّتْ أَقْدَامَنَا وَانصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ',
        transliteration: 'Rabbana afrigh \'alayna sabran wa thabbit aqdamana wansurna \'alal-qawmil-kafirin',
        translations: {
            english: 'Our Lord, pour upon us patience and plant firmly our feet and give us victory over the disbelieving people.',
            urdu: 'اے ہمارے رب! ہم پر صبر انڈیل دے اور ہمارے قدم جمائے رکھ اور کافر قوم کے مقابلے میں ہماری مدد فرما۔',
            hindi: 'ऐ हमारे रब! हम पर सब्र उंडेल दे और हमारे कदम जमाए रख और काफिर कौम के मुकाबले में हमारी मदद फरमा।',
            bangla: 'হে আমাদের পালনকর্তা! আমাদের মনে ধৈর্য্য সৃষ্টি করে দাও এবং আমাদের পা সুদৃঢ় রাখ এবং কাফের সম্প্রদায়ের বিরুদ্ধে আমাদের সাহায্য কর।'
        },
        reference: 'Surah Al-Baqarah 2:250',
        benefits: 'For patience during trials, steadfastness, and victory against opposition.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/002250.mp3'
    },
    {
        id: 107,
        category: 'quranic',
        title: 'Rabbana Taqabbal Minna (Acceptance)',
        arabic: 'رَبَّنَا تَقَبَّلْ مِنَّا إِنَّكَ أَنتَ السَّمِيعُ الْعَلِيمُ',
        transliteration: 'Rabbana taqabbal minna innaka antas-Sami\'ul-\'Alim',
        translations: {
            english: 'Our Lord, accept [this] from us. Indeed You are the Hearing, the Knowing.',
            urdu: 'اے ہمارے رب! ہم سے قبول فرما، بے شک تو ہی سننے والا اور جاننے والا ہے۔',
            hindi: 'ऐ हमारे रब! हमसे कबूल फरमा, बेशक तू ही सुनने वाला और जानने वाला है।',
            bangla: 'হে আমাদের পালনকর্তা! আমাদের পক্ষ থেকে কবুল কর। নিশ্চয়ই তুমি শ্রবণকারী, সর্বজ্ঞ।'
        },
        reference: 'Surah Al-Baqarah 2:127',
        benefits: 'Recited by Ibrahim (AS) and Ismail (AS) while building the Kaaba. Use after performing any good deed.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/002127.mp3'
    },
    {
        id: 108,
        category: 'quranic',
        title: 'Rabbi Zidni \'Ilma (Knowledge)',
        arabic: 'رَّبِّ زِدْنِي عِلْمًا',
        transliteration: 'Rabbi zidni \'ilma',
        translations: {
            english: 'My Lord, increase me in knowledge.',
            urdu: 'اے میرے رب! میرے علم میں اضافہ فرما۔',
            hindi: 'ऐ मेरे रब! मेरे इल्म में इज़ाफा फरमा।',
            bangla: 'হে আমার পালনকর্তা! আমার জ্ঞান বৃদ্ধি করুন।'
        },
        reference: 'Surah Taha 20:114',
        benefits: 'For increasing knowledge and understanding.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/020114.mp3'
    },
    {
        id: 109,
        category: 'quranic',
        title: 'Rabbana La Tu\'akhidhna (Forgiveness for mistakes)',
        arabic: 'رَبَّنَا لاَ تُؤَاخِذْنَا إِن نَّسِينَا أَوْ أَخْطَأْنَا',
        transliteration: 'Rabbana la tu\'akhidhna in nasina aw akhta\'na',
        translations: {
            english: 'Our Lord, do not impose blame upon us if we have forgotten or erred.',
            urdu: 'اے ہمارے رب! ہماری گرفت نہ کر اگر ہم بھول جائیں یا ہم سے چوک ہو جائے۔',
            hindi: 'ऐ हमारे रब! हमारी पकड़ न कर अगर हम भूल जाएं या हमसे चूक हो जाए।',
            bangla: 'হে আমাদের পালনকর্তা! যদি আমরা ভুলে যাই কিংবা ভুল করি, তবে আমাদেরকে ধৃত করবেন না।'
        },
        reference: 'Surah Al-Baqarah 2:286',
        benefits: 'Protection from punishment for unintentional mistakes.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/002286.mp3'
    },
    {
        id: 110,
        category: 'quranic',
        title: 'Rabbi Ishrah Li Sadri (Confidence & Speech)',
        arabic: 'رَبِّ اشْرَحْ لِي صَدْرِي وَيَسِّرْ لِي أَمْرِي وَاحْلُلْ عُقْدَةً مِّن لِّسَانِي يَفْقَهُوا قَوْلِي',
        transliteration: 'Rabbi ishrah li sadri wa yassir li amri wahlul \'uqdatan min lisani yafqahu qawli',
        translations: {
            english: 'My Lord, expand for me my breast [with assurance], and ease for me my task, and untie the knot from my tongue that they may understand my speech.',
            urdu: 'اے میرے رب! میرا سینہ کھول دے، اور میرا کام آسان کر دے، اور میری زبان کی گرہ کھول دے تاکہ وہ میری بات سمجھ سکیں۔',
            hindi: 'ऐ मेरे रब! मेरा सीना खोल दे, और मेरा काम आसान कर दे, और मेरी ज़बान की गिरह खोल दे ताकि वो मेरी बात समझ सकें।',
            bangla: 'হে আমার পালনকর্তা! আমার বক্ষ প্রশস্ত করে দিন। এবং আমার কাজ সহজ করে দিন। এবং আমার জিহবা থেকে জড়তা দূর করে দিন। যাতে তারা আমার কথা বুঝতে পারে।'
        },
        reference: 'Surah Taha 20:25-28',
        benefits: 'Dua of Musa (AS) for confidence, eloquence, and success in tasks.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/020025.mp3'
    },

    // --- MORNING ---
    {
        id: 201,
        category: 'morning',
        title: 'Upon Waking Up',
        arabic: 'الْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ',
        transliteration: 'Alhamdu lillahil-ladhi ahyana ba\'da ma amatana wa-ilayhin-nushur',
        translations: {
            english: 'All praise is for Allah who gave us life after having taken it from us and unto Him is the resurrection.',
            urdu: 'تمام تعریفیں اللہ کے لیے ہیں جس نے ہمیں مارنے کے بعد زندہ کیا اور اسی کی طرف لوٹنا ہے۔',
            hindi: 'सब तारीफ अल्लाह के लिए है जिसने हमें मारने के बाद जिंदा किया और उसी की तरफ लौटना है।',
            bangla: 'সমস্ত প্রশংসা আল্লাহর জন্য যিনি আমাদের মৃত্যু দান করার পর আমাদের জীবন দান করেছেন এবং তাঁরই নিকট আমাদের পুনরুত্থান।'
        },
        reference: 'Sahih Al-Bukhari 6312',
        benefits: 'Acknowledging Allah\'s power over life and death immediately upon waking.',
        audio: ''
    },
    {
        id: 202,
        category: 'morning',
        title: 'Morning Remembrance (Ayatul Kursi)',
        arabic: 'اللَّهُ لاَ إِلَهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ...',
        transliteration: 'Allahu la ilaha illa Huwal-Hayyul-Qayyum...',
        translations: {
            english: 'Allah - there is no deity except Him, the Ever-Living, the Sustainer of [all] existence...',
            urdu: 'اللہ، اس کے سوا کوئی معبود نہیں، وہ زندہ ہے، سب کا تھامنے والا ہے...',
            hindi: 'अल्लाह, उसके सिवा कोई माबूद नहीं, वह ज़िंदा है, सबका थामने वाला है...',
            bangla: 'আল্লাহ, তিনি ছাড়া কোন ইলাহ নেই, তিনি চিরঞ্জীব, সুপ্রতিষ্ঠিত ধারক...'
        },
        reference: 'Quran 2:255',
        benefits: 'Protection from Shaytan until evening.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/002255.mp3'
    },
    {
        id: 203,
        category: 'morning',
        title: 'Morning Supplication',
        arabic: 'أَصْبَحْنَا وَأَصْبَحَ الْمُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ، لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ',
        transliteration: 'Asbahna wa-asbahal-mulku lillah walhamdu lillah la ilaha illal-lah, wahdahu la sharika lah',
        translations: {
            english: 'We have entered the morning and at this very time the whole kingdom belongs to Allah. All praise is due to Allah. There is no god but Allah, the One; He has no partner.',
            urdu: 'ہم نے صبح کی اور سارا ملک اللہ کا ہو کر صبح ہوئی، تمام تعریفیں اللہ کے لیے ہیں، اللہ کے سوا کوئی معبود نہیں، وہ اکیلا ہے اس کا کوئی شریک نہیں۔',
            hindi: 'हमने सुबह की और सारा मुल्क अल्लाह का होकर सुबह हुई, तमाम तारीफें अल्लाह के लिए हैं, अल्लाह के सिवा कोई माबूद नहीं, वह अकेला है उसका कोई शरीक नहीं।',
            bangla: 'আমরা সকালে উপনীত হলাম এবং রাজত্ব আল্লাহর জন্য সকালে উপনীত হলো। সকল প্রশংসা আল্লাহর জন্য। আল্লাহ ছাড়া কোন ইলাহ নেই, তিনি একক, তাঁর কোন শরীক নেই।'
        },
        reference: 'Sahih Muslim 2723',
        benefits: 'Affirming Allah\'s sovereignty at the start of the day.',
        audio: ''
    },
    {
        id: 204,
        category: 'morning',
        title: 'Asking for Goodness',
        arabic: 'اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلاً مُتَقَبَّلاً',
        transliteration: 'Allahumma inni as\'aluka \'ilman nafi\'an, wa rizqan tayyiban, wa \'amalan mutaqabbalan',
        translations: {
            english: 'O Allah, I ask You for beneficial knowledge, goodly provision and acceptable deeds.',
            urdu: 'اے اللہ! میں تجھ سے نفع بخش علم، پاکیزہ رزق اور مقبول عمل کا سوال کرتا ہوں۔',
            hindi: 'ऐ अल्लाह! मैं तुझसे नफा बख्श इल्म, पाकीज़ा रिज़्क और मकबूल अमल का सवाल करता हूँ।',
            bangla: 'হে আল্লাহ! আমি আপনার নিকট উপকারী জ্ঞান, পবিত্র রিযিক এবং কবুলযোগ্য আমলের প্রার্থনা করছি।'
        },
        reference: 'Sunan Ibn Majah 925',
        benefits: 'Recite this every morning after Fajr prayer.',
        audio: ''
    },

    // --- EVENING ---
    {
        id: 301,
        category: 'evening',
        title: 'Evening Supplication',
        arabic: 'أَمْسَيْنَا وَأَمْسَى الْمُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ، لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ',
        transliteration: 'Amsayna wa-amsal-mulku lillah walhamdu lillah la ilaha illal-lah, wahdahu la sharika lah',
        translations: {
            english: 'We have entered the evening and at this very time the whole kingdom belongs to Allah. All praise is due to Allah. There is no god but Allah, the One; He has no partner.',
            urdu: 'ہم نے شام کی اور سارا ملک اللہ کا ہو کر شام ہوئی، تمام تعریفیں اللہ کے لیے ہیں، اللہ کے سوا کوئی معبود نہیں، وہ اکیلا ہے اس کا کوئی شریک نہیں۔',
            hindi: 'हमने शाम की और सारा मुल्क अल्लाह का होकर शाम हुई, तमाम तारीफें अल्लाह के लिए हैं, अल्लाह के सिवा कोई माबूद नहीं, वह अकेला है उसका कोई शरीक नहीं।',
            bangla: 'আমরা সন্ধ্যায় উপনীত হলাম এবং রাজত্ব আল্লাহর জন্য সন্ধ্যায় উপনীত হলো। সকল প্রশংসা আল্লাহর জন্য...'
        },
        reference: 'Sahih Muslim 2723',
        benefits: 'Affirming Allah\'s sovereignty at the end of the day.',
        audio: ''
    },
    {
        id: 302,
        category: 'evening',
        title: 'Protection from Harm (Evening)',
        arabic: 'أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ',
        transliteration: 'A\'udhu bikalimatillahi at-tammati min sharri ma khalaq',
        translations: {
            english: 'I seek refuge in the Perfect Words of Allah from the evil of what He has created.',
            urdu: 'میں اللہ کے مکمل کلمات کی پناہ چاہتا ہوں اس چیز کے شر سے جو اس نے پیدا کی۔',
            hindi: 'मैं अल्लाह के मुकम्मल कलिमात की पनाह चाहता हूँ उस चीज़ के शर से जो उसने पैदा की।',
            bangla: 'আমি আল্লাহর পরিপূর্ণ কালিমাসমূহের ওসিলায় তাঁর সৃষ্টির অনিষ্ট হতে আশ্রয় চাইছি।'
        },
        reference: 'Sahih Muslim 2709',
        benefits: 'Whoever recites this three times in the evening will not be harmed by anything that night.',
        audio: ''
    },

    // --- PRAYER (SALAH) ---
    {
        id: 401,
        category: 'prayer',
        title: 'Dua After Adhan',
        arabic: 'اللَّهُمَّ رَبَّ هَذِهِ الدَّعْوَةِ التَّامَّةِ، وَالصَّلاَةِ الْقَائِمَةِ، آتِ مُحَمَّداً الْوَسِيلَةَ وَالْفَضِيلَةَ، وَابْعَثْهُ مَقَاماً مَحْمُوداً الَّذِي وَعَدْتَهُ',
        transliteration: 'Allahumma Rabba hadhihid-da\'watit-tammah, was-salatil-qa\'imah, ati Muhammadanil-wasilata wal-fadilah, wab\'ath-hu maqaman mahmudanil-ladhi wa\'adtah',
        translations: {
            english: 'O Allah, Lord of this perfect call and established prayer. Grant Muhammad the intercession and favor, and raise him to the Maqam Mahmud (Praised Station) which You have promised him.',
            urdu: 'اے اللہ! اس کامل پکار اور کھڑی ہونے والی نماز کے رب، محمد ﷺ کو وسیلہ اور فضیلت عطا فرما، اور انہیں اس مقام محمود پر فائز فرما جس کا تو نے ان سے وعدہ کیا ہے۔',
            hindi: 'ऐ अल्लाह! इस कामिल पुकार और कायम होने वाली नमाज़ के रब, मुहम्मद (सल्ल.) को वसीला और फज़ीलत अता फरमा, और उन्हें उस मकामे महमूद पर फाइज़ फरमा जिसका तूने उनसे वादा किया है।',
            bangla: 'হে আল্লাহ! এই পরিপূর্ণ আহ্বান এবং প্রতিষ্ঠিত সালাতের তুমিই প্রভু। মুহাম্মদ (সা.)-কে অসীলা ও মর্যাদা দান কর এবং তাঁকে সেই প্রশংসিত স্থানে পৌঁছিয়ে দাও, যার প্রতিশ্রুতি তুমি তাঁকে দিয়েছ।'
        },
        reference: 'Sahih Al-Bukhari 614',
        benefits: 'Intercession of the Prophet (SAW) becomes incumbent.',
        audio: ''
    },
    {
        id: 402,
        category: 'prayer',
        title: 'Entering the Mosque',
        arabic: 'اللَّهُمَّ افْتَحْ لِي أَبْوَابَ رَحْمَتِكَ',
        transliteration: 'Allahumma-ftah li abwaba rahmatik',
        translations: {
            english: 'O Allah, open the gates of Your mercy for me.',
            urdu: 'اے اللہ! میرے لیے اپنی رحمت کے دروازے کھول دے۔',
            hindi: 'ऐ अल्लाह! मेरे लिए अपनी रहमत के दरवाज़े खोल दे।',
            bangla: 'হে আল্লাহ! আমার জন্য তোমার রহমতের দরজাসমূহ খুলে দাও।'
        },
        reference: 'Sahih Muslim 713',
        benefits: 'Seeking Allah\'s mercy upon entering His house.',
        audio: ''
    },
    {
        id: 403,
        category: 'prayer',
        title: 'Leaving the Mosque',
        arabic: 'اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ',
        transliteration: 'Allahumma inni as-aluka min fadlik',
        translations: {
            english: 'O Allah, I ask You from Your bounty.',
            urdu: 'اے اللہ! میں تجھ سے تیرے فضل کا سوال کرتا ہوں۔',
            hindi: 'ऐ अल्लाह! मैं तुझसे तेरे फज़ल का सवाल करता हूँ।',
            bangla: 'হে আল্লাহ! আমি তোমার নিকট তোমার অনুগ্রহ প্রার্থনা করছি।'
        },
        reference: 'Sahih Muslim 713',
        benefits: 'Seeking Allah\'s bounty when going out into the world.',
        audio: ''
    },
    {
        id: 404,
        category: 'prayer',
        title: 'Dua Qunoot (Witr)',
        arabic: 'اللَّهُمَّ اهْدِنِي فِيمَنْ هَدَيْتَ، وَعَافِنِي فِيمَنْ عَافَيْتَ، وَتَوَلَّنِي فِيمَنْ تَوَلَّيْتَ، وَبَارِكْ لِي فِيمَا أَعْطَيْتَ، وَقِنِي شَرَّ مَا قَضَيْتَ، فَإِنَّكَ تَقْضِي وَلاَ يُقْضَى عَلَيْكَ، إِنَّهُ لاَ يَذِلُّ مَنْ وَالَيْتَ، تَبَارَكْتَ رَبَّنَا وَتَعَالَيْتَ',
        transliteration: 'Allahummahdini fiman hadayt, wa \'afini fiman \'afayt, wa tawallani fiman tawallayt, wa barik li fima a\'tayt, wa qini sharra ma qadayt, fa-innaka taqdi wa la yuqda \'alayk, innahu la yadhillu man walayt, tabarakta Rabbana wa ta\'alayt',
        translations: {
            english: 'O Allah, guide me among those whom You have guided, pardon me among those whom You have pardoned, turn to me in friendship among those on whom You have turned in friendship, and bless me in what You have bestowed, and save me from the evil of what You have decreed. For verily You decree and none can decree over You. For verily he whom You show allegiance to is never abased. Blessed are You, our Lord, and Exalted.',
            urdu: 'اے اللہ! مجھے ہدایت دے ان لوگوں میں جنہیں تو نے ہدایت دی، اور مجھے عافیت دے ان لوگوں میں جنہیں تو نے عافیت دی...',
            hindi: 'ऐ अल्लाह! मुझे हिदायत दे उन लोगों में जिन्हें तूने हिदायत दी...',
            bangla: 'হে আল্লাহ! আপনি আমাকে হেদায়াত করুন, যাদের আপনি হেদায়াত করেছেন। আমাকে নিরাপত্তা প্রদান করুন, যাদের আপনি নিরাপত্তা প্রদান করেছেন...'
        },
        reference: 'Abu Dawud 1425',
        benefits: 'Recited in the Witr prayer.',
        audio: ''
    },

    // --- FOOD ---
    {
        id: 501,
        category: 'food',
        title: 'Before Eating',
        arabic: 'بِسْمِ اللَّهِ',
        transliteration: 'Bismillah',
        translations: {
            english: 'In the name of Allah.',
            urdu: 'اللہ کے نام سے۔',
            hindi: 'अल्लाह के नाम से।',
            bangla: 'আল্লাহর নামে।'
        },
        reference: 'Sahih Al-Bukhari 5376',
        benefits: 'Seeking blessing in the food. If forgotten, say "Bismillahi awwalahu wa akhirahu".',
        audio: ''
    },
    {
        id: 502,
        category: 'food',
        title: 'After Eating',
        arabic: 'الْحَمْدُ لِلَّهِ الَّذِي أَطْعَمَنِي هَذَا وَرَزَقَنِيهِ مِنْ غَيْرِ حَوْلٍ مِنِّي وَلاَ قُوَّةٍ',
        transliteration: 'Alhamdu lillahil-ladhi at\'amani hadha wa razaqanihi min ghayri hawlin minni wa la quwwah',
        translations: {
            english: 'All praise is due to Allah Who fed me this and provided it for me without any might or power on my part.',
            urdu: 'تمام تعریفیں اللہ کے لیے ہیں جس نے مجھے یہ کھلایا اور مجھے یہ رزق دیا میری کسی طاقت اور قوت کے بغیر۔',
            hindi: 'सब तारीफ अल्लाह के लिए है जिसने मुझे यह खिलाया और मुझे यह रिज़्क दिया मेरी किसी ताकत और कुव्वत के बिना।',
            bangla: 'সকল প্রশংসা আল্লাহর জন্য যিনি আমাকে এটি খাওয়ালেন এবং আমার কোন চেষ্টা ও সামর্থ্য ছাড়াই আমাকে এ রিযিক দান করলেন।'
        },
        reference: 'At-Tirmidhi 3458',
        benefits: 'Forgiveness of past sins.',
        audio: ''
    },
    {
        id: 503,
        category: 'food',
        title: 'Dua for the Host',
        arabic: 'أَطْعَمَكُمُ الأَبْرَارُ، وَصَلَّتْ عَلَيْكُمُ الْمَلاَئِكَةُ، وَأَفْطَرَ عِنْدَكُمُ الصَّائِمُونَ',
        transliteration: 'At\'amakumul-abrar, wa sallat \'alaykumul-mala\'ikah, wa aftara \'indakumus-sa\'imun',
        translations: {
            english: 'May the righteous eat your food, may the angels send prayers upon you, and may those who have been fasting break their fast with you.',
            urdu: 'نیک لوگ تمہارا کھانا کھائیں، فرشتے تم پر رحمت بھیجیں، اور روزہ دار تمہارے پاس افطار کریں۔',
            hindi: 'नेक लोग तुम्हारा खाना खाएं, फरिश्ते तुम पर रहमत भेजें, और रोज़ेदार तुम्हारे पास इफ्तार करें।',
            bangla: 'নেককারগণ যেন তোমাদের খাবার খায়, ফেরেশতাগণ যেন তোমাদের জন্য দু‘আ করে এবং রোযাদারগণ যেন তোমাদের কাছে ইফতার করে।'
        },
        reference: 'Abu Dawud 3854',
        benefits: 'Supplication for those who serve you food.',
        audio: ''
    },

    // --- TRAVEL ---
    {
        id: 601,
        category: 'travel',
        title: 'Dua for Travel',
        arabic: 'سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ وَإِنَّا إِلَى رَبِّنَا لَمُنْقَلِبُونَ',
        transliteration: 'Subhanalladhi sakh-khara lana hadha wa ma kunna lahu muqrinin. Wa inna ila Rabbina lamunqalibun',
        translations: {
            english: 'Glory is to Him Who has subjected this to us, and we were not able to do it. And surely to our Lord we will return.',
            urdu: 'پاک ہے وہ ذات جس نے اسے ہمارے تابع کر دیا حالانکہ ہم اسے قابو میں لانے والے نہ تھے، اور یقیناً ہم اپنے رب کی طرف لوٹنے والے ہیں۔',
            hindi: 'पाक है वह ज़ात जिसने इसे हमारे ताबे कर दिया हालाँकि हम इसे काबू में लाने वाले न थे, और यकीनन हम अपने रब की तरफ लौटने वाले हैं।',
            bangla: 'মহা পবিত্র সেই সত্তা যিনি একে আমাদের জন্য বশীভূত করে দিয়েছেন, অথচ আমরা একে বশ করতে সক্ষম ছিলাম না। আর আমরা অবশ্যই আমাদের রবের কাছে ফিরে যাব।'
        },
        reference: 'Surah Az-Zukhruf 43:13-14',
        benefits: 'Acknowledging Allah\'s favor and remembering the final journey.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/043013.mp3'
    },
    {
        id: 602,
        category: 'travel',
        title: 'Entering a Town or City',
        arabic: 'اللَّهُمَّ رَبَّ السَّمَاوَاتِ السَّبْعِ وَمَا أَظْلَلْنَ، وَرَبَّ الأَرَضِينَ السَّبْعِ وَمَا أَقْلَلْنَ... أَسْأَلُكَ خَيْرَ هَذِهِ الْقَرْيَةِ',
        transliteration: 'Allahumma Rabbas-samawatis-sab\'i wa ma azlaln... as-aluka khayra hadhihil-qaryah',
        translations: {
            english: 'O Allah, Lord of the seven heavens and what they shadow... I ask You for the good of this town.',
            urdu: 'اے اللہ! ساتوں آسمانوں کے رب... میں تجھ سے اس بستی کی بھلائی مانگتا ہوں۔',
            hindi: 'ऐ अल्लाह! सातों आसमानों के रब... मैं तुझसे इस बस्ती की भलाई मांगता हूँ।',
            bangla: 'হে আল্লাহ! সাত আসমানের প্রভু... আমি আপনার কাছে এই জনপদের কল্যাণ চাই।'
        },
        reference: 'Al-Hakim 2/100',
        benefits: 'Protection from the harm of new places.',
        audio: ''
    },

    // --- FORGIVENESS ---
    {
        id: 701,
        category: 'forgiveness',
        title: 'Sayyidul Istighfar',
        arabic: 'اللَّهُمَّ أَنْتَ رَبِّي لاَ إِلَهَ إِلاَّ أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ، أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ، أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ، وَأَبُوءُ بِذَنْبِي فَاغْفِرْ لِي فَإِنَّهُ لاَ يَغْفِرُ الذُّنُوبَ إِلاَّ أَنْتَ',
        transliteration: 'Allahumma Anta Rabbi la ilaha illa Anta, khalaqtani wa ana \'abduka, wa ana \'ala \'ahdika wa wa\'dika mastata\'tu, a\'udhu bika min sharri ma sana\'tu, abu-u laka bini\'matika \'alayya, wa abu-u bidhanbi faghfir li fa-innahu la yaghfirudh-dhunuba illa Ant',
        translations: {
            english: 'O Allah, You are my Lord, none has the right to be worshipped except You. You created me and I am Your servant, and I am faithful to my covenant and my promise to You as much as I can. I seek refuge with You from all the evil I have done. I acknowledge before You all the blessings You have bestowed upon me, and I confess to You all my sins. So I entreat You to forgive me, for no one can forgive sins except You.',
            urdu: 'اے اللہ! تو میرا رب ہے، تیرے سوا کوئی معبود نہیں، تو نے مجھے پیدا کیا اور میں تیرا بندہ ہوں، اور میں اپنی استطاعت کے مطابق تیرے عہد اور وعدے پر قائم ہوں۔ میں اپنے کیے ہوئے شر سے تیری پناہ مانگتا ہوں۔ میں تیرے انعام کا اقرار کرتا ہوں جو مجھ پر ہے، اور میں اپنے گناہ کا اعتراف کرتا ہوں، پس مجھے بخش دے، کیونکہ تیرے سوا کوئی گناہوں کو نہیں بخش سکتا۔',
            hindi: 'ऐ अल्लाह! तू मेरा रब है, तेरे सिवा कोई माबूद नहीं, तूने मुझे पैदा किया और मैं तेरा बंदा हूँ...',
            bangla: 'হে আল্লাহ! আপনি আমার রব্ব, আপনি ছাড়া আর কোন ইলাহ নেই। আপনি আমাকে সৃষ্টি করেছেন এবং আমি আপনার বান্দা...'
        },
        reference: 'Sahih Al-Bukhari 6306',
        benefits: 'The master of seeking forgiveness. Paradise guaranteed if died that day.',
        audio: ''
    },
    {
        id: 702,
        category: 'forgiveness',
        title: 'Short Istighfar',
        arabic: 'أَسْتَغْفِرُ اللَّهَ وَأَتُوبُ إِلَيْهِ',
        transliteration: 'Astaghfirullah wa atubu ilaih',
        translations: {
            english: 'I seek forgiveness from Allah and repent to Him.',
            urdu: 'میں اللہ سے معافی مانگتا ہوں اور اس کی طرف توبہ کرتا ہوں۔',
            hindi: 'मैं अल्लाह से माफी मांगता हूँ और उसकी तरफ तौबा करता हूँ।',
            bangla: 'আমি আল্লাহর কাছে ক্ষমা প্রার্থনা করছি এবং তাঁর দিকেই ফিরে আসছি।'
        },
        reference: 'Sahih Al-Bukhari 6307',
        benefits: 'Prophet Muhammad (SAW) used to say this more than 70 times a day.',
        audio: ''
    },

    // --- PROTECTION ---
    {
        id: 801,
        category: 'protection',
        title: 'Protection from Harm',
        arabic: 'بِسْمِ اللَّهِ الَّذِي لاَ يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الأَرْضِ وَلاَ فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ',
        transliteration: 'Bismillahil-ladhi la yadurru ma\'as-mihi shay\'un fil-ardi wa la fis-sama\'i, wa Huwas-Sami\'ul-\'Alim',
        translations: {
            english: 'In the Name of Allah with Whose Name nothing can cause harm in the earth nor in the heavens, and He is the All-Hearing, the All-Knowing.',
            urdu: 'اللہ کے نام سے جس کے نام کے ساتھ زمین اور آسمان میں کوئی چیز نقصان نہیں پہنچا سکتی، اور وہ سننے والا جاننے والا ہے۔',
            hindi: 'अल्लाह के नाम से जिसके नाम के साथ ज़मीन और आसमान में कोई चीज़ नुकसान नहीं पहुँचा सकती, और वह सुनने वाला जानने वाला है।',
            bangla: 'আল্লাহর নামে, যার নামের বরকতে আসমান ও যমিনের কোন বস্তুই ক্ষতি করতে পারে না। তিনি সর্বশ্রোতা ও সর্বজ্ঞ।'
        },
        reference: 'Sunan At-Tirmidhi 3388',
        benefits: 'Recite 3 times morning & evening for complete protection.',
        audio: ''
    },
    {
        id: 802,
        category: 'protection',
        title: 'Seeking Refuge from Evil Eye',
        arabic: 'أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّةِ مِنْ كُلِّ شَيْطَانٍ وَهَامَّةٍ، وَمِنْ كُلِّ عَيْنٍ لاَمَّةٍ',
        transliteration: 'A\'udhu bikalimatillahi-tammah min kulli shaytanin wa hammah, wa min kulli \'aynin lammah',
        translations: {
            english: 'I seek refuge in the perfect words of Allah from every devil and every poisonous reptile, and from every evil eye.',
            urdu: 'میں اللہ کے مکمل کلمات کی پناہ مانگتا ہوں ہر شیطان اور زہریلے جانور سے، اور ہر نظر بد سے۔',
            hindi: 'मैं अल्लाह के मुकम्मल कलिमात की पनाह मांगता हूँ हर शैतान और ज़हरीले जानवर से, और हर नज़र-ए-बद से।',
            bangla: 'আমি আল্লাহর পরিপূর্ণ কালিমাসমূহের আশ্রয়ে পানাহ চাচ্ছি সকল শয়তান ও বিষধর জীবজন্তু থেকে এবং সকল বদনযর থেকে।'
        },
        reference: 'Sahih Al-Bukhari 3371',
        benefits: 'Dua used by Prophet Ibrahim (AS) for Ismail and Ishaq, and Prophet Muhammad (SAW) for Hasan and Husayn.',
        audio: ''
    },

    // --- ILLNESS ---
    {
        id: 901,
        category: 'illness',
        title: 'Visiting the Sick',
        arabic: 'لاَ بَأْسَ طَهُورٌ إِنْ شَاءَ اللَّهُ',
        transliteration: 'La ba\'sa tahurun in sha\' Allah',
        translations: {
            english: 'Do not worry, it will be a purification (for you), if Allah wills.',
            urdu: 'کوئی ہرج نہیں، یہ (بیماری) گناہوں سے پاک کرنے والی ہے اگر اللہ نے چاہا۔',
            hindi: 'कोई हरज नहीं, यह (बीमारी) गुनाहों से पाक करने वाली है अगर अल्लाह ने चाहा।',
            bangla: 'ভয় নেই, আল্লাহর মেহেরবানীতে আরোগ্য লাভ করবে এবং গোনাহ মাফ হবে ইন্শাআল্লাহ।'
        },
        reference: 'Sahih Al-Bukhari 3616',
        benefits: 'Sunnah when visiting someone ill.',
        audio: ''
    },
    {
        id: 902,
        category: 'illness',
        title: 'Dua for Pain in Body',
        arabic: 'بِسْمِ اللَّهِ (3 times) ... أَعُوذُ بِاللَّهِ وَقُدْرَتِهِ مِنْ شَرِّ مَا أَجِدُ وَأُحَاذِرُ (7 times)',
        transliteration: 'Bismillah (3x)... A\'udhu billahi wa qudratihi min sharri ma ajidu wa uhadhiru (7x)',
        translations: {
            english: 'In the name of Allah (3x). I seek refuge in Allah and His power from the evil of what I feel and that which I am wary of (7x).',
            urdu: 'اللہ کے نام سے (۳ بار)... میں اللہ اور اس کی قدرت کی پناہ مانگتا ہوں اس تکلیف کے شر سے جو میں محسوس کرتا ہوں اور جس سے میں ڈرتا ہوں (۷ بار)۔',
            hindi: 'अल्लाह के नाम से (3 बार)... मैं अल्लाह और उसकी कुदरत की पनाह मांगता हूँ उस तकलीफ के शर से जो मैं महसूस करता हूँ और जिससे मैं डरता हूँ (7 बार)।',
            bangla: 'আল্লাহর নামে (৩ বার)... আমি আল্লাহ এবং তাঁর ক্ষমতার আশ্রয় চাচ্ছি, যে ব্যথা আমি অনুভব করছি এবং যার আমি আশঙ্কা করছি, তার অনিষ্ট থেকে (৭ বার)।'
        },
        reference: 'Sahih Muslim 2202',
        benefits: 'Place hand on pain and recite.',
        audio: ''
    },

    // --- FAMILY ---
    {
        id: 1001,
        category: 'family',
        title: 'Entering Home',
        arabic: 'بِسْمِ اللَّهِ وَلَجْنَا، وَبِسْمِ اللَّهِ خَرَجْنَا، وَعَلَى رَبِّنَا تَوَكَّلْنَا',
        transliteration: 'Bismillahi walajna, wa bismillahi kharajna, wa \'ala Rabbina tawakkalna',
        translations: {
            english: 'In the Name of Allah we enter, in the Name of Allah we leave, and upon our Lord we depend.',
            urdu: 'اللہ کے نام سے ہم داخل ہوئے، اور اللہ کے نام سے ہم نکلے، اور اپنے رب پر ہم نے بھروسہ کیا۔',
            hindi: 'अल्लाह के नाम से हम दाखिल हुए, और अल्लाह के नाम से हम निकले, और अपने रब पर हमने भरोसा किया।',
            bangla: 'আল্লাহর নামে আমরা প্রবেশ করলাম, আল্লাহর নামেই আমরা বের হলাম এবং আমাদের রবের ওপরই আমরা ভরসা করলাম।'
        },
        reference: 'Abu Dawud 5096',
        benefits: 'Blessing for the home and protection from devils.',
        audio: ''
    },
    {
        id: 1002,
        category: 'family',
        title: 'Leaving Home',
        arabic: 'بِسْمِ اللَّهِ تَوَكَّلْتُ عَلَى اللَّهِ، وَلاَ حَوْلَ وَلاَ قُوَّةَ إِلاَّ بِاللَّهِ',
        transliteration: 'Bismillahi tawakkaltu \'alal-lah, wa la hawla wa la quwwata illa billah',
        translations: {
            english: 'In the name of Allah, I place my trust in Allah, and there is no might nor power except with Allah.',
            urdu: 'اللہ کے نام سے، میں نے اللہ پر بھروسہ کیا، اور اللہ کے سوا کوئی طاقت اور قوت نہیں۔',
            hindi: 'अल्लाह के नाम से, मैंने अल्लाह पर भरोसा किया, और अल्लाह के सिवा कोई ताकत और कुव्वत नहीं।',
            bangla: 'আল্লাহর নামে, আমি আল্লাহর ওপর ভরসা করলাম। আল্লাহর সাহায্য ছাড়া পাপ কাজ থেকে বিরত থাকার সাধ্য এবং সৎকাজ করার শক্তি কারো নেই।'
        },
        reference: 'Abu Dawud 5095',
        benefits: 'It is said to him: "You are guided, defended and protected."',
        audio: ''
    },
    {
        id: 1003,
        category: 'family',
        title: 'Dua for Offspring',
        arabic: 'رَبِّ لَا تَذَرْنِي فَرْدًا وَأَنتَ خَيْرُ الْوَارِثِينَ',
        transliteration: 'Rabbi la tadharni fardan wa anta khayrul warithin',
        translations: {
            english: 'My Lord! Do not leave me alone, and You are the Best of inheritors.',
            urdu: 'اے میرے رب! مجھے اکیلا نہ چھوڑ اور تو بہترین وارث ہے۔',
            hindi: 'ऐ मेरे रब! मुझे अकेला न छोड़ और तू बेहतरीन वारिस है।',
            bangla: 'হে আমার পালনকর্তা! আমাকে একা রেখো না। তুমি তো উত্তম ওয়ারিস।'
        },
        reference: 'Surah Al-Anbiyya 21:89',
        benefits: 'Dua of Zakariya (AS) for children.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/021089.mp3'
    },

    // --- HAJJ & UMRAH ---
    {
        id: 1101,
        category: 'hajj',
        title: 'Talbiyah',
        arabic: 'لَبَّيْكَ اللَّهُمَّ لَبَّيْكَ، لَبَّيْكَ لاَ شَرِيكَ لَكَ لَبَّيْكَ، إِنَّ الْحَمْدَ وَالنِّعْمَةَ لَكَ وَالْمُلْكَ لاَ شَرِيكَ لَكَ',
        transliteration: 'Labbayk Allahumma labbayk, labbayka la sharika laka labbayk, innal-hamda wan-ni\'mata laka wal-mulk, la sharika lak',
        translations: {
            english: 'Here I am, O Allah, here I am. Here I am, You have no partner, here I am. Verily all praise and blessings are Yours, and all sovereignty, You have no partner.',
            urdu: 'میں حاضر ہوں اے اللہ میں حاضر ہوں، میں حاضر ہوں تیرا کوئی شریک نہیں میں حاضر ہوں، بے شک تمام تعریفیں اور نعمتیں تیری ہیں اور بادشاہت بھی، تیرا کوئی شریک نہیں۔',
            hindi: 'मैं हाज़िर हूँ ऐ अल्लाह मैं हाज़िर हूँ, मैं हाज़िर हूँ तेरा कोई शरीक नहीं मैं हाज़िर हूँ...',
            bangla: 'আমি হাজির হে আল্লাহ! আমি হাজির। আমি হাজির, আপনার কোন শরীক নেই, আমি হাজির। নিশ্চয়ই সকল প্রশংসা ও নি‘আমত আপনারই এবং রাজত্বও, আপনার কোন শরীক নেই।'
        },
        reference: 'Sahih Al-Bukhari 1549',
        benefits: 'The slogan of Hajj and Umrah.',
        audio: ''
    },

    // --- EMOTION (Stress/Sadness) ---
    {
        id: 1201,
        category: 'emotion',
        title: 'Dua for Anxiety and Sorrow',
        arabic: 'اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَالْحَزَنِ، وَالْعَجْزِ وَالْكَسَلِ، وَالْبُخْلِ وَالْجُبْنِ، وَضَلَعِ الدَّيْنِ وَغَلَبَةِ الرِّجَالِ',
        transliteration: 'Allahumma inni a\'udhu bika minal-hammi wal-hazan, wal-\'ajzi wal-kasal, wal-bukhli wal-jubn, wa dala\'id-dayni wa ghalabatir-rijal',
        translations: {
            english: 'O Allah, I seek refuge in You from anxiety and sorrow, weakness and laziness, miserliness and cowardice, the burden of debts and being overpowered by men.',
            urdu: 'اے اللہ! میں تیری پناہ مانگتا ہوں فکر اور غم سے، عاجزی اور سستی سے، بخل اور بزدلی سے، قرض کے بوجھ اور لوگوں کے غلبے سے۔',
            hindi: 'ऐ अल्लाह! मैं तेरी पनाह मांगता हूँ फिक्र और गम से, आज़िज़ी और सुस्ती से...',
            bangla: 'হে আল্লাহ! আমি আপনার আশ্রয় নিচ্ছি দুশ্চিন্তা ও পেরেশানি থেকে, অক্ষমতা ও অলসতা থেকে, কৃপণতা ও ভীরুতা থেকে, ঋণের ভার ও মানুষের দমন-পীড়ন থেকে।'
        },
        reference: 'Sahih Al-Bukhari 6369',
        benefits: 'Relief from mental and emotional distress.',
        audio: ''
    },
    {
        id: 1202,
        category: 'emotion',
        title: 'Dua in Distress',
        arabic: 'لاَ إِلَهَ إِلاَّ أَنْتَ سُبْحَانَكَ إِنِّي كُنْتُ مِنَ الظَّالِمِينَ',
        transliteration: 'La ilaha illa anta subhanaka inni kuntu minaz-zalimin',
        translations: {
            english: 'There is no god but You, glory to You, I was indeed among the wrongdoers.',
            urdu: 'تیرے سوا کوئی معبود نہیں، تو پاک ہے، بے شک میں ظالموں میں سے تھا۔',
            hindi: 'तेरे सिवा कोई माबूद नहीं, तू पाक है, बेशक मैं ज़ालिमों में से था।',
            bangla: 'তুমি ব্যতীত সত্য কোন উপাস্য নেই; আমি তোমার পবিত্রতা ঘোষণা করছি। আমি তো অন্যায়কারী।'
        },
        reference: 'Surah Al-Anbiyya 21:87',
        benefits: 'Dua of Yunus (AS) in the whale. Allah removes distress.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/021087.mp3'
    },

    // --- RAMADAN & FASTING ---
    {
        id: 1301,
        category: 'ramadan',
        title: 'Breaking Fast (Iftar)',
        arabic: 'ذَهَبَ الظَّمَأُ وَابْتَلَّتِ الْعُرُوقُ وَثَبَتَ الأَجْرُ إِنْ شَاءَ اللَّهُ',
        transliteration: 'Dhahabaz-zama\'u wabtallatil-\'uruqu wa thabatal-ajru in sha\' Allah',
        translations: {
            english: 'The thirst is gone, the veins are moistened and the reward is confirmed, if Allah wills.',
            urdu: 'پیاس بجھ گئی، رگیں تر ہو گئیں اور اجر ثابت ہو گیا اگر اللہ نے چاہا۔',
            hindi: 'प्यास बुझ गई, रगें तर हो गईं और अज्र साबित हो गया अगर अल्लाह ने चाहा।',
            bangla: 'পিপাসা নিবারিত হলো, শিরা-উপশিরা সিক্ত হলো এবং আল্লাহর ইচ্ছায় পুরস্কার নির্ধারিত হলো।'
        },
        reference: 'Abu Dawud 2357',
        benefits: 'Sunnah dua upon breaking fast.',
        audio: ''
    },

    // --- PARENTS ---
    {
        id: 1401,
        category: 'parents',
        title: 'Dua for Parents',
        arabic: 'رَّبِّ ارْحَمْهُمَا كَمَا رَبَّيَانِي صَغِيرًا',
        transliteration: 'Rabbi irhamhuma kama rabbayani saghira',
        translations: {
            english: 'My Lord, have mercy upon them as they brought me up [when I was] small.',
            urdu: 'اے میرے رب! ان دونوں پر رحم فرما جیسا کہ انہوں نے بچپن میں مجھے پالا۔',
            hindi: 'ऐ मेरे रब! उन दोनों पर रहम फरमा जैसा कि उन्होंने बचपन में मुझे पाला।',
            bangla: 'হে আমার পালনকর্তা! তাদের উভয়ের প্রতি রহম কর, যেমন তারা আমাকে শৈশবকালে লালন-পালন করেছেন।'
        },
        reference: 'Surah Al-Isra 17:24',
        benefits: 'Best dua for parents.',
        audio: 'https://everyayah.com/data/Alafasy_128kbps/017024.mp3'
    }
];